
import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import NewsletterForm from "./NewsletterForm";
import { useTranslatedContent } from "@/hooks/useTranslatedContent";

const NewsletterPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  const content = {
    title: "Restez informé !",
    description: "Inscrivez-vous à notre newsletter pour ne rien manquer de nos actualités et offres spéciales."
  };

  const { translatedContent } = useTranslatedContent(content);

  useEffect(() => {
    // Vérifie si la popup a déjà été montrée au cours de cette session
    const hasPopupBeenShown = sessionStorage.getItem("newsletterPopupShown");
    
    if (hasPopupBeenShown) {
      setHasShown(true);
      return;
    }
    
    const handleScroll = () => {
      if (!hasShown) {
        const scrollPosition = window.scrollY + window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;
        
        if (scrollPosition > pageHeight / 2) {
          setIsOpen(true);
          setHasShown(true);
          sessionStorage.setItem("newsletterPopupShown", "true");
          window.removeEventListener("scroll", handleScroll);
        }
      }
    };

    // Ajouter un délai avant d'attacher l'écouteur de défilement
    const timer = setTimeout(() => {
      window.addEventListener("scroll", handleScroll);
    }, 1000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasShown]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="p-0 border-none bg-transparent">
        <div className="bg-white rounded-lg p-8 max-w-md w-full relative">
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold mb-2">{translatedContent.title}</h2>
            <p className="text-gray-600">
              {translatedContent.description}
            </p>
          </div>
          <NewsletterForm />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NewsletterPopup;
